import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_BO_DEMO_ILO1 = {
  title: "Forecasting the likelihood \nof the on-time completion \nof an order",
  subtitle: "Business Operations Demo",
  text: '<span style="font-weight:bold">Customer Delight</span> — Elevating customer\nsatisfaction with timely and efficient service.',
  label: { iconPath: "start.png", text: "ILO AI" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_107"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_105"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_demo_screens_base.png",
  rightSideVideo: "ILO/ILO1/INF_CMT_827.23_Business Demo_Part 3_R1.mp4",
  pageNumber: "ILO_106",
};

export default DATA_BO_DEMO_ILO1;
